<template>
  <div class="container">
    <h1 >Contato</h1>

    <div class="row">
        <div class='col-12 col-sm-4'>
	        <p>End.: SCRN 716 Bl. H Ent.: 16 Sala 102.&nbsp;CEP: 70.770 - 680.</p><p>Telefone: (55) 61 3711 10 30</p><p><strong>ajr@ajresportes.com.br</strong></p><p><br></p>
      	</div>
        <router-link to="/politica-privacidade">Política de Privacidade</router-link>
    </div>

  </div>
</template>


<script>
  export default {

  }
</script>

<style>

</style>
